import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      'globals.validations.required': 'שדה חובה',
      'globals.validations.email': 'יש להזין מייל תקין',
      'globals.validations.hebrew': 'יש להזין אותיות בעברית בלבד',
      'globals.validations.uid': 'יש להזין תעודת זהות תקינה',
      'globals.validations.date': 'יש להזין תאריך תקין',
      'globals.validations.number': 'ניתן להזין ספרות בלבד',
      'globals.validations.phone': 'יש להזין טלפון תקין',
      'globals.validations.otp': 'יש להזין קוד תקין',
      'globals.validations.autocomplete': 'חובה לבחור פריט מהרשימה',
      'globals.yes': 'כן',
      'globals.no': 'לא',
      'globals.continue': 'המשך',
      'globals.back': 'חזור',
      'globals.add': 'הוספה',
      'globals.remove': 'הסרה',
      'globals.delete': 'מחיקה',
      'globals.edit': 'עריכה',
      'globals.save': 'שמירה',
      'globals.cancel': 'ביטול',
      'globals.close': 'סגירה',
      'globals.error.title': 'חלה שגיאה',
      'globals.error.message': 'התרחשה שגיאה בתהליך. אנא נסה שוב',
      'globals.privacyPolicy': 'מדיניות הפרטיות',

      'layout.default.action.light.label': 'עבור למצב לילה',
      'layout.default.action.dark.label': 'עבור למצב יום',

      'components.meeting.info.name': 'יועצי חברת קרדיט פרו',
      'components.meeting.info.title': 'פגישת יעוץ',
      'components.meeting.counselor.placeholder': 'בחר יועץ',
      'components.meeting.info.time': 'משך הפגישה {{minutes}} דקות',
      'components.meeting.info.video': 'הפגישה תתקיים בשיחת וידאו',
      'components.meeting.info.date': 'בתאריך {{date}}',
      'components.meeting.info.hour': 'בשעה {{time}}',
      'components.meeting.info.date.empty': 'עדיין לא נבחר תאריך',
      'components.meeting.info.hour.empty': 'עדיין לא נבחרה שעה',
      'components.meeting.time.action': 'קבע פגישה עם היועץ',

      'pages.main.title': 'דף ראשי',
      'pages.main.goto': 'עבור לדף התחברות',

      'pages.login.title': 'התחברות',
      'pages.login.subTitle': 'לצפייה בהצעת המשכנתא ואישור המשך התהליך, יש להתחבר למערכת',
      'pages.login.inputs.mobile': 'מספר טלפון',
      'pages.login.inputs.uid': 'תעודת זהות',
      'pages.login.action': 'התחבר',

      'pages.otp.title': 'התחברות',
      'pages.otp.subTitle': 'להמשך התהליך הזן את הקוד שנשלח אל מספר הטלפון שלך',
      'pages.otp.resendText': 'לא קיבלת עדיין קוד?',
      'pages.otp.resendButton': 'שלח שוב',
      'pages.otp.tooManyAttempts': 'עליך להתחבר מחדש כדי לנסות שוב',
      'pages.otp.backToLogin': 'חזור לעמוד התחברות',

      'pages.summary.title': 'סיכום ההצעה',
      'pages.summary.subtitle': 'להלן סיכום ההצעה שהתקבלה על בסיס הנתונים שנמסרו על ידי הלקוח',
      'pages.summary.label.loanType': 'מטרת ההלוואה',
      'pages.summary.label.paymentPerMonth': 'החזר חודשי',
      'pages.summary.label.borrowerNumber': 'מספר הלווים',
      'pages.summary.label.loanAmount': 'סכום הלוואה המבוקשת',
      'pages.summary.label.paymentPeriodInMonths': 'תקופת ההלוואה בחודשים',
      'pages.summary.label.maxPaymentPerMonth': 'ההחזר המרבי הצפוי בתקופת המשכנתא	',
      'pages.summary.label.returnOfInterest': 'החזר ריבית',
      'pages.summary.label.linkedReturn': 'החזר הצמדת מדד',
      'pages.summary.label.totalPaymentInPeriodEnd': 'סכום החזר בסוף התקופה',
      'pages.summary.label.sumOfReturnsOfInterest': 'החזר ריבית',
      'pages.summary.label.forEvryShekelYouWillPay': 'עבור כל שקל תשלם',
      'pages.summary.title.disposalBoardFor': 'לוח סילוקין ל',
      'pages.summary.title.disposalBoard': 'לוח סילוקין',
      'pages.summary.title.borrowerDetails': 'פרטי הלווים',
      'pages.summary.label.fullName': 'שם מלא',
      'pages.summary.label.idNumber': 'תעודת זהות',
      'pages.summary.label.phoneNumber': 'טלפון',
      'pages.summary.title.planA': 'תוכנית א',
      'pages.summary.title.planB': 'ברמת סיכון גבוהה יותר',
      'pages.summary.recommendedPlan': 'תוכנית מומלצת',
      'pages.summary.higerRiskPlan': 'תוכנית בסיכון גבוה יותר',

      'pages.summary.table.head.month': 'חודש',
      'pages.summary.table.head.remaining': 'יתרת הקרן',
      'pages.summary.table.head.monthlyPaymentWithoutInterest': 'תשלום ע״ח קרן',
      'pages.summary.table.head.monthlyPaymentInterest': 'תשלום ע״ח ריבית',
      'pages.summary.table.head.totalPayment': 'החזר חודשי כולל',

      'pages.mortgageCyclesSummary.title.comparation': 'השוואה לפני/אחרי',
      'pages.mortgageCyclesSummary.table.label.totalAmount': 'סך הלוואה',
      'pages.mortgageCyclesSummary.table.label.paymentPerMonth': 'החזר חודשי',
      'pages.mortgageCyclesSummary.table.label.maxPaymentPerMonth': 'החזר מקסימלי',
      'pages.mortgageCyclesSummary.table.label.sumOfReturnsOfInterest': 'החזר ריבית',
      'pages.mortgageCyclesSummary.table.label.sumOfReturnsOfLinkage': 'החזר הצמדת מדד',
      'pages.mortgageCyclesSummary.table.label.totalPaymentInPeriodEnd': 'החזר בסוף תקופה',
      'pages.mortgageCyclesSummary.table.label.forEvryShekelYouWillPay': 'עבור כל שקל תשלם',
      'pages.mortgageCyclesSummary.table.head.index': 'מדד',
      'pages.mortgageCyclesSummary.table.head.before': 'לפני',
      'pages.mortgageCyclesSummary.table.head.after': 'אחרי',

      'pages.agree.title': 'תנאי ההסכם',
      'pages.agree.subTitle': 'קרא את תנאי ההסכם וחתום על מנת להמשיך בתהליך',

      'pages.pay.title': 'תשלום',
      'pages.pay.subTitle': 'לביצוע התשלום מלא פרטי כרטיס אשראי תקין',

      'pages.paymentError.title': 'התשלום לא הצליח',
      'pages.paymentError.message': 'משהו השתבש בעיבוד התשלום שלך. אל דאגה — אף חיוב לא בוצע.',
      'pages.paymentError.actions.home': 'חזרה לדף הבית',
      'pages.paymentError.actions.contact': 'צור קשר עם תמיכה',
      'pages.paymentError.actions.contactEmail': 'support@creditpro.com',

      'pages.error.title': 'מצטערים',
      'pages.error.error': 'אין מה לראות פה...',
      'pages.error.link.title': 'בחזרה לעמוד הראשי',

      'pages.success.slogan': 'נבנה במיוחד בשבילך',
      'pages.success.title': `
        ההצעה בדרך אליך.<br/>
        בהצלחה! 
      `,
      'pages.success.subtitle': `
        ההצעה האישית שלך כבר בדרך אליך למייל,<br/>
        שם תמצא את כל הפרטים והמסמכים הדרושים<br/>
        על מנת לעשות את הצעד הבא.
      `,
      'pages.success.action.title': 'להורדת ההצעה שלי',
      'pages.success.block.title': 'כעת, בוא נדבר!',
      'pages.success.block.content': `
        לקביעת המשך התהליך, אנו מזמינים אותך לפגישת ייעוץ אישית עם אחד מהמומחים שלנו.<br/>
        בפגישת וידאו נבחן יחד את האפשרויות שלך ונבנה תוכנית מותאמת אישית.<br/>
        בחר את היועץ והמועד שנוחים לך, ואנחנו נלווה אותך בכל שלב.
      `,
      'pages.success.block.meeting.title': 'הפגישה שלך נקבעה',
      'pages.success.block.meeting.content': `
        פגישת יעוץ בינך לבין יועץ שבחרת, בתאריך <strong>{{date}}</strong>
        בין השעות <strong>{{start}}</strong> עד <strong>{{end}}</strong>
      `,
      'pages.success.block.meeting.link': `
        לנוחיותך, להלן קישור לפגישה כפי שנקבעה ביומן האישי שלך:<br/>
        <a target="_blank" href="{{link}}">{{link}}</a>`,
      'pages.success.chooseDateForAppointment': 'בחרו את התאריך והשעה הנוחים עבורכם לצורך פגישה הייעוץ',
      'pages.success.button.downloadPdf': 'הורד את ההצעה',

      'pages.pay.block.secure.content': 'התשלום שאתה מבצע באתר מתבצע באמצעות מערכת מאובטחת המתקדמת לתקני האבטחה המחמירים ביותר.',
      'pages.pay.block.after.content': 'לאחר השלמת התשלום, תקבל מייל עם פרטי ההזמנה ואישור רכישה. תודה שבחרת בנו כשותפים לתהליך ההלוואה.',

      'pages.mortgageCyclesSummary.totalsComparison.title': 'פירוט נתוני המשכנתא הנוכחית מול נתוני המשכנתא המומלצת',
      'pages.mortgageCyclesSummary.title': 'סיכום ההצעה',
      'pages.mortgageCyclesSummary.subtitle': 'להלן סיכום ההצעה שהתקבלה על בסיס הנתונים שנמסרו על ידי הלקוח',
      'pages.mortgageCyclesSummary.label.loanType': 'מטרת ההלוואה',
      'pages.mortgageCyclesSummary.label.paymentPerMonth': 'החזר חודשי',
      'pages.mortgageCyclesSummary.label.borrowerNumber': 'מספר הלווים',
      'pages.mortgageCyclesSummary.label.loanAmount': 'סכום הלוואה המבוקשת',
      'pages.mortgageCyclesSummary.label.paymentPeriodInMonths': 'תקופת ההלוואה בחודשים',
      'pages.mortgageCyclesSummary.label.maxPaymentPerMonth': 'ההחזר המרבי הצפוי בתקופת המשכנתא	',
      'pages.mortgageCyclesSummary.label.returnOfInterest': 'החזר ריבית',
      'pages.mortgageCyclesSummary.label.linkedReturn': 'החזר הצמדת מדד',
      'pages.mortgageCyclesSummary.label.totalPaymentInPeriodEnd': 'סכום החזר בסוף התקופה',
      'pages.mortgageCyclesSummary.label.sumOfReturnsOfInterest': 'החזר ריבית',
      'pages.mortgageCyclesSummary.label.forEvryShekelYouWillPay': 'עבור כל שקל תשלם',
      'pages.mortgageCyclesSummary.title.disposalBoardFor': 'לוח סילוקין לאחר שיפור ההלוואות',
      'pages.mortgageCyclesSummary.title.borrowerDetails': 'פרטי הלווים',
      'pages.mortgageCyclesSummary.label.fullName': 'שם מלא',
      'pages.mortgageCyclesSummary.label.idNumber': 'תעודת זהות',
      'pages.mortgageCyclesSummary.label.phoneNumber': 'טלפון',

      'pages.mortgageCyclesSummary.table.head.month': 'חודש',
      'pages.mortgageCyclesSummary.table.head.remaining': 'יתרת הקרן',
      'pages.mortgageCyclesSummary.table.head.monthlyPaymentWithoutInterest': 'תשלום ע״ח קרן',
      'pages.mortgageCyclesSummary.table.head.monthlyPaymentInterest': 'תשלום ע״ח ריבית',
      'pages.mortgageCyclesSummary.table.head.totalPayment': 'החזר חודשי כולל',
      'pages.mortgageCyclesSummary.newMonthlyPaymentInfo': 'התשלום החודשי המעודכן של ההלוואה',
      'pages.mortgageCyclesSummary.monthlySavingInfo': 'סכום חודשי שנוכל לחסוך לכם',
      'pages.mortgageCyclesSummary.totalSavingInfo': '{{percentage}}% פחות לאורך תקופת המשכנתא',
      'pages.mortgageCyclesSummary.returnConversionTitle': 'עבור כל שקל תשלמו',
      'pages.mortgageCyclesSummary.returnConversionInfo': 'במקום {{amount}} ₪ כיום',
      'pages.mortgageCyclesSummary.newMonthlyPayment': 'תשלום חודשי חדש',
      'pages.mortgageCyclesSummary.monthlySaving': 'חיסכון חודשי',
      'pages.mortgageCyclesSummary.totalSaving': 'חיסכון כולל',

      'components.totalsComparison.title': 'השוואת סכומים לפני ואחרי החישוב',
      'components.totalsComparison.field': 'שדה',
      'components.totalsComparison.before': 'לפני',
      'components.totalsComparison.after': 'אחרי',
      'components.totalsComparison.improvement': 'שיעור השינוי',
      'components.totalsComparison.noDataAvailable': 'אין נתונים זמינים להשוואה',
      'components.totalsComparison.noChange': 'אין שינוי',
      'components.totalsComparison.decreasedBy': 'הופחת ב-{{amount}} ({{percentage}}%)',
      'components.totalsComparison.increasedBy': 'הוגדל ב-{{amount}} ({{percentage}}%)',
      'components.totalsComparison.decreasedByWithoutAmount': 'הופחת ב- ({{percentage}}%)',
      'components.totalsComparison.increasedByWithoutAmount': 'הוגדל ב- ({{percentage}}%)',
      'components.totalsComparison.totalAmount': 'למשכנתא בגובה',
      'components.totalsComparison.loanPeriod': 'לתקופה של',
      'components.totalsComparison.monthlyPayment': 'התשלום החודשי ההתחלתי של ההלוואה',
      'components.totalsComparison.interestRepayment': 'סך החזר הריבית בהלוואה',
      'components.totalsComparison.principalRepayment': 'תשלום קרן',
      'components.totalsComparison.finalPayment': 'סך ההחזר בסוף תקופת ההלוואה',
      'components.totalsComparison.linkageRepayment': 'סך החזר הצמדה בהלוואה',
      'components.totalsComparison.maxMonthlyPayment': 'תשלום חודשי מקסימלי',
      'components.totalsComparison.returnConversion': 'עבור כל שקל תשלום (יחס ההחזר)',
      'components.totalsComparison.summary': 'סיכום השיפור',
      'components.totalsComparison.summaryText': 'השוואה זו מראה את השיפור בתנאי ההלוואה שלך. ירידה בתשלומים החודשיים ובריבית, ועלייה בתשלום הקרן הם סימנים חיוביים.',

      'pages.offer.box.title.regular': 'נתוני תמהיל ברמת סיכון נמוכה',
      'pages.offer.box.title.medium': 'נתוני תמהיל ברמת סיכון בנונית',
      'pages.offer.box.title.high': 'נתוני תמהיל ברמת סיכון גבוהה',
      'pages.offer.box.title.risk': 'נתוני תמהיל ברמת סיכון גבוהה',

    },
    status: 200,
  },

  error: {
    response: {},
    status: 500,
  },
};

const localesHeHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(0);
  return HttpResponse.json(response, status);
};

export {
  localesHeHandler,
};
